import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import SignupList from "./SignupList";
import DeletedList from "./DeletedList";
import MovedUsers from "./MovedUsers";
import Blacklist from "./Blacklist";
import FrontPageAdmin from "./FrontPageAdmin";
import SignupPageAdmin from "./SignupPageAdmin";
import CompoPageAdmin from "./CompoPageAdmin";
import FoodPageAdmin from "./FoodPageAdmin";
import InfoPageAdmin from "./InfoPageAdmin";
import SeatmapAdmin from "./SeatmapAdmin";
import ActivityLogs from "./ActivityLogs";
import SuperAdmin from "./SuperAdmin";
import AdminUserManagement from "./AdminUserManagement";
import FadeIn from "react-fade-in";
import { Redirect, Route, Switch, Link, withRouter } from "react-router-dom";
import "./Admin.css";

const menuList = [
  { component: SignupList, name: "Påmeldte brukere", path: "users" },
  { component: SeatmapAdmin, name: "Plasskart", path: "seatmap" },
  { component: DeletedList, name: "Slettede brukere", path: "deleted" },
  { component: MovedUsers, name: "Flyttede brukere", path: "moved" },
  { component: Blacklist, name: "Blacklist", path: "blacklist" },
  { component: AdminUserManagement, name: "Admin brukere", path: "adminusers" },
  { component: ActivityLogs, name: "Aktivitetslogg", path: "activitylog" },
  { component: FrontPageAdmin, name: "Forside", path: "frontpage" },
  { component: SignupPageAdmin, name: "Påmeldingsside", path: "signuppage" },
  { component: CompoPageAdmin, name: "Composide", path: "compopage" },
  { component: FoodPageAdmin, name: "Matside", path: "foodpage" },
  { component: InfoPageAdmin, name: "Infoside", path: "infopage" },
  { component: SuperAdmin, name: "Superadmin", path: "super" }
];

export default withAuth(withRouter(
  class Admin extends Component {
    logout = () => {
      this.props.auth.logout();
      window.location.href = "/login";
    };

    render() {
      const { authenticated, currentUser, location } = this.props;

      if (!authenticated) {
        return <Redirect to="/login" />;
      }

      const currentPath = location.pathname.split('/')[2] || 'users'; // Default to users

      const mainContent = (
        <div>
          <button className="btn btn-light btn-lg btno" onClick={this.logout}>
            Logg ut
          </button>
        </div>
      );

      const menu = menuList.map((item, index) => (
        <Link key={index} to={`/admin/${item.path}`} className="btnMenuLink">
          <button
            className={
              "btn btno btnMenu " +
              (currentPath === item.path ? "btn-success" : "btn-info")
            }
          >
            {item.name}
          </button>
        </Link>
      ));

      return (
        <FadeIn>
          <div className="jumbotron">
            <h1 className="display-4">Admin</h1>
            <h5>Logget inn som {currentUser && currentUser.username} </h5>
            {mainContent}
          </div>
          <div className="AdminMenu">{menu}</div>

          <Switch>
            <Route path="/admin/users" render={() => <SignupList auth={this.props.auth} />} />
            <Route path="/admin/seatmap" component={SeatmapAdmin} />
            <Route path="/admin/deleted" component={DeletedList} />
            <Route path="/admin/moved" component={MovedUsers} />
            <Route path="/admin/blacklist" component={Blacklist} />
            <Route path="/admin/adminusers" component={AdminUserManagement} />
            <Route path="/admin/activitylog" component={ActivityLogs} />
            <Route path="/admin/frontpage" component={FrontPageAdmin} />
            <Route path="/admin/signuppage" component={SignupPageAdmin} />
            <Route path="/admin/compopage" component={CompoPageAdmin} />
            <Route path="/admin/foodpage" component={FoodPageAdmin} />
            <Route path="/admin/infopage" component={InfoPageAdmin} />
            <Route path="/admin/super" component={SuperAdmin} />
            {/* Default redirect to users page */}
            <Redirect from="/admin" to="/admin/users" exact />
          </Switch>
        </FadeIn>
      );
    }
  }
));



// WEBPACK FOOTER //
// ./src/Components/Admin/Admin.js